import type { ReactNode } from 'react'

import { Skeleton } from '@/components/ui/skeleton'

/**
 * Loading skeleton placeholder for the connector detail view.
 */
export const ConnectorDetailSkeleton: React.FC = (): ReactNode => (
  <div className="connector-detail-view space-y-6">
    <Skeleton className="h-8 w-40" />
    <Skeleton className="h-16 w-full" />
    <Skeleton className="h-24 w-full" />
  </div>
)

ConnectorDetailSkeleton.displayName = 'ConnectorDetailSkeleton'
